export const GROSS_PERCENT_TYPE = 'shared-fiverr-seller-percent';
